import { API_URL } from '../config';

const SESSION_INVALID_EVENT = 'ticksy:session-invalid';
const validationRequests = new Map();
const REQUEST_TIMEOUT_MS = 10000;

const normalizeUserData = (userData) => {
  if (!userData) return null;

  return {
    ...userData,
    role: typeof userData.role === 'string'
      ? { name: userData.role }
      : userData.role,
  };
};

export const getToken = () => localStorage.getItem('token');

export const setToken = (token) => {
  if (token) {
    localStorage.setItem('token', token);
  } else {
    localStorage.removeItem('token');
  }
};

export const setUser = (user) => {
  const normalizedUser = normalizeUserData(user);
  if (normalizedUser) {
    localStorage.setItem('user', JSON.stringify(normalizedUser));
  } else {
    localStorage.removeItem('user');
  }
};

export const getUser = () => {
  const user = localStorage.getItem('user');
  return user ? normalizeUserData(JSON.parse(user)) : null;
};

export const logout = () => {
  setToken(null);
  setUser(null);
};

export const isAuthenticated = () => !!getToken();

export const validateSession = (token) => {
  if (!token) {
    return Promise.resolve({ status: null });
  }

  if (validationRequests.has(token)) {
    return validationRequests.get(token);
  }

  const request = (async () => {
    const controller = new AbortController();
    const timeoutId = window.setTimeout(
      () => controller.abort(),
      REQUEST_TIMEOUT_MS
    );

    try {
      const response = await fetch(`${API_URL}/auth/me`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        signal: controller.signal,
      });

      if (!response.ok) {
        return { status: response.status };
      }

      return {
        status: response.status,
        user: normalizeUserData(await response.json()),
      };
    } catch {
      return { status: null };
    } finally {
      window.clearTimeout(timeoutId);
      validationRequests.delete(token);
    }
  })();

  validationRequests.set(token, request);
  return request;
};

export const clearSessionIfCurrent = (token) => {
  if (!token || getToken() !== token) {
    return false;
  }

  logout();
  window.dispatchEvent(new Event(SESSION_INVALID_EVENT));
  return true;
};

export const SESSION_INVALID_EVENT_NAME = SESSION_INVALID_EVENT;
